var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MB-star_n_web",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.81,
    y1: -2.294,
    x2: 2.577,
    y2: -2.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cdd0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b5bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a5acaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9ba3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#98a0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#828a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#667075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#535c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#475158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#434d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475157"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.92,
    y1: -2.494,
    x2: 2.685,
    y2: -3.137,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b1f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81898d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b3b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d2d5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#dee0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 30.215,
    y1: -2.765,
    x2: 30.557,
    y2: -3.705,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c1c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9ba1a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d8487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#687074",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5b6469",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576065",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.17,
    y1: -2.6,
    x2: 2.67,
    y2: -3.466,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4.848,
    y1: -14.442,
    x2: 4.778,
    y2: -14.641,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00111e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 26.948,
    y1: -6.07,
    x2: 26.281,
    y2: -5.904,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5.312,
    y1: -14.168,
    x2: 5.141,
    y2: -14.253,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#02131f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 5.004,
    y1: -15.019,
    x2: 4.978,
    y2: -14.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02131f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 23.34,
    y1: -5.459,
    x2: 22.617,
    y2: -5.473,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02131f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 23.364,
    y1: -5.457,
    x2: 22.874,
    y2: -5.468,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b474e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 4.706,
    y1: -4.562,
    x2: 5.957,
    y2: -4.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24303a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25323b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27343c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 118.278,
    y1: -42.384,
    x2: 118.278,
    y2: -41.371,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a5abaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5abaf",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3.887,
    y1: -2.223,
    x2: 3.887,
    y2: -3.223,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dee0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c9c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ea4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82898c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434d54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 4.861,
    y1: -3.477,
    x2: 4.35,
    y2: -3.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2b373f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36424a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#49545b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#646d73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#868d92",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b0b5b8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e1e3e4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outer_24_",
    d: "M63.3,32A31.3,31.3,0,1,1,32,.7,31.283,31.283,0,0,1,63.3,32ZM32,2.6A29.4,29.4,0,1,0,61.4,32,29.32,29.32,0,0,0,32,2.6Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_45",
    "data-name": "\\u8DEF\\u5F84 45",
    d: "M32,2.6A29.4,29.4,0,1,0,61.4,32,29.32,29.32,0,0,0,32,2.6Zm0,56.9A27.5,27.5,0,1,1,59.5,32,27.484,27.484,0,0,1,32,59.5Z",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_46",
    "data-name": "\\u8DEF\\u5F84 46",
    d: "M32,63.3A31.3,31.3,0,1,0,.7,32,31.283,31.283,0,0,0,32,63.3ZM32,0A32,32,0,1,1,0,32,32.094,32.094,0,0,1,32,0Z",
    opacity: 0.4,
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_47",
    "data-name": "\\u8DEF\\u5F84 47",
    d: "M2.2,32.1A29.9,29.9,0,0,1,32,2.2h0A29.832,29.832,0,0,1,61.8,32.1h0A29.725,29.725,0,0,1,32,61.8h0A29.725,29.725,0,0,1,2.2,32.1Zm9.3-20.6A29.112,29.112,0,0,0,2.9,32.1h0a29.03,29.03,0,0,0,8.5,20.5h0A29.448,29.448,0,0,0,32,61.1h0a28.617,28.617,0,0,0,20.5-8.5h0A28.617,28.617,0,0,0,61,32.1h0a29.448,29.448,0,0,0-8.5-20.6h0A28.7,28.7,0,0,0,32,2.9h0a28.7,28.7,0,0,0-20.5,8.6Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_48",
    "data-name": "\\u8DEF\\u5F84 48",
    d: "M32,59.6A27.577,27.577,0,0,1,12.5,12.5a27.577,27.577,0,1,1,39,39A27.381,27.381,0,0,1,32,59.6Zm0-.8A26.7,26.7,0,1,0,13.1,13.2,26,26,0,0,0,5.2,32,26.8,26.8,0,0,0,32,58.8Z",
    opacity: 0.4,
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_49",
    "data-name": "\\u8DEF\\u5F84 49",
    d: "M32.4,31.4",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_50",
    "data-name": "\\u8DEF\\u5F84 50",
    d: "M56.3,45c-.5-.4-19.8-15.7-19.8-15.7L32,3.6a1.708,1.708,0,0,0-.9.8l-3.2,25L8,44.7s-.4.5-.6.8a1.949,1.949,0,0,0-.1.8h0L31.9,36.2,56.5,46.3h0A1.427,1.427,0,0,0,56.3,45Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_51",
    "data-name": "\\u8DEF\\u5F84 51",
    d: "M32.2,32.8,32,37.4l22.6,9.1a1.8,1.8,0,0,0,2-.2L32.5,32.7A.192.192,0,0,0,32.2,32.8Z",
    fill: "#565f64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_52",
    "data-name": "\\u8DEF\\u5F84 52",
    d: "M32.2,32.8A23.886,23.886,0,0,0,35,36.7a23.1,23.1,0,0,0,4.9,3.9l14.7,5.9a1.8,1.8,0,0,0,2-.2L32.5,32.7A.192.192,0,0,0,32.2,32.8Z",
    fill: "url(#linear-gradient-5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_53",
    "data-name": "\\u8DEF\\u5F84 53",
    d: "M56.5,45.4c0-.1-.1-.2-.2-.4L35.7,29.9l-2.8,1.8s.2.1.3,0a2.5,2.5,0,0,1,1.5,0c.5.2,21.8,13.8,21.8,13.8Z",
    fill: "rgba(164,170,174,0.6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_54",
    "data-name": "\\u8DEF\\u5F84 54",
    d: "M55.8,44.5,36.6,29.3h0l-.9.6L56.3,45.1A2.651,2.651,0,0,0,55.8,44.5Z",
    fill: "#333e46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_55",
    "data-name": "\\u8DEF\\u5F84 55",
    d: "M32.5,31.3l-.1.1s0,.2.2.1c.1-.1,3-1.6,4-2.2l-3.5-24a1.742,1.742,0,0,0-1.2-1.6l.4,27.8Z",
    fill: "#565f64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_56",
    "data-name": "\\u8DEF\\u5F84 56",
    d: "M30.8,5.3V6.6L28.6,28.7a.909.909,0,0,0,.4.8l1.3,1,.9-24.4.1-1.9A1.626,1.626,0,0,0,30.8,5.3Z",
    fill: "rgba(164,170,174,0.6)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_57",
    "data-name": "\\u8DEF\\u5F84 57",
    d: "M29.6,30.9l-1.2-1L8.1,44.6s-.6.4-.7.8h0l.7-.4h0L29.4,31.6C29.8,31.4,29.9,31.2,29.6,30.9Z",
    fill: "rgba(164,170,174,0.6)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_58",
    "data-name": "\\u8DEF\\u5F84 58",
    d: "M31.7,32.8c0-.1-.1-.2-.2-.1L7.3,46.4a2.01,2.01,0,0,0,2,.2l22.6-9.1Z",
    fill: "#565f64"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_59",
    "data-name": "\\u8DEF\\u5F84 59",
    d: "M32.4,31.4l.1-.1-.1.1h0a.1.1,0,0,0,.1.1h.1c.1-.1,3-1.6,4-2.2l-.4-2.9h0L33.1,5.3a1.222,1.222,0,0,0-.3-.9s1.5,20.2,1.5,22.4A6.527,6.527,0,0,1,32.4,31.4Z",
    fill: "url(#linear-gradient-6)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_60",
    "data-name": "\\u8DEF\\u5F84 60",
    d: "M31.7,32.8c0-.1-.1-.2-.2-.1L7.3,46.4a2.01,2.01,0,0,0,2,.2l22.6-9.1Z",
    fill: "url(#linear-gradient-7)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_61",
    "data-name": "\\u8DEF\\u5F84 61",
    d: "M9.3,46.5l22.6-9.1L31.7,33a5.728,5.728,0,0,1-3,3.5h0c-1.4.8-14.8,7.4-19.6,9.7a6.315,6.315,0,0,1-.9.4A1.1,1.1,0,0,0,9.3,46.5Z",
    opacity: 0.8,
    fill: "url(#linear-gradient-8)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_62",
    "data-name": "\\u8DEF\\u5F84 62",
    d: "M32.5,31.3l-.1.1s0,.2.2.1c.1-.1,3-1.6,4-2.2l-3.5-24a1.742,1.742,0,0,0-1.2-1.6l.4,27.8Z",
    fill: "url(#linear-gradient-9)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_63",
    "data-name": "\\u8DEF\\u5F84 63",
    d: "M32.5,31.3l-.1.1s0,.2.2.1c.1-.1,3-1.6,4-2.2l-3.5-24a1.742,1.742,0,0,0-1.2-1.6l.4,27.8Z",
    fill: "url(#linear-gradient-10)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_64",
    "data-name": "\\u8DEF\\u5F84 64",
    d: "M5.1,44.4C4.4,42.8.4,35,4.8,20H3.1a49.484,49.484,0,0,0-2,7.5s-.2,1-.3,2.1A22.749,22.749,0,0,0,.7,32a26.182,26.182,0,0,0,1.5,9.5,29.194,29.194,0,0,0,8.2,12.9A28.684,28.684,0,0,0,23,60.3C22.3,60.2,10.3,55.1,5.1,44.4Z",
    fill: "url(#linear-gradient-11)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_65",
    "data-name": "\\u8DEF\\u5F84 65",
    d: "M32.4,32.6h-.9c.1,0,.2,0,.2.1l.2,4.6H32l.2-4.6c0-.1.1-.2.2-.1Z",
    fill: "url(#linear-gradient-12)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_66",
    "data-name": "\\u8DEF\\u5F84 66",
    d: "M42,2.3c10.5,4,20.4,15,20.4,28.9A30.344,30.344,0,0,1,32,61.7v1.6a31.324,31.324,0,0,0,10-61Z",
    fill: "url(#linear-gradient-13)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_67",
    "data-name": "\\u8DEF\\u5F84 67",
    d: "M32.3.7h0Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_68",
    "data-name": "\\u8DEF\\u5F84 68",
    d: "M58.8,20.2C51.8,4.1,36,3.2,35.1,3.1H35C47.1,5.3,54.8,13.2,57.5,21.5v.1a31.4,31.4,0,0,1,1.9,10.3,27.345,27.345,0,0,1-2.2,11c-.1.5-.2,1.1-.3,1.1h1.6C63.3,35,61.2,25.9,58.8,20.2Z",
    fill: "url(#linear-gradient-14)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_69",
    "data-name": "\\u8DEF\\u5F84 69",
    d: "M2.2,32.1A29.9,29.9,0,0,1,32,2.2h0A29.832,29.832,0,0,1,61.8,32.1h0A29.725,29.725,0,0,1,32,61.8h0A29.725,29.725,0,0,1,2.2,32.1Zm9.3-20.6A29.112,29.112,0,0,0,2.9,32.1h0a29.03,29.03,0,0,0,8.5,20.5h0A29.448,29.448,0,0,0,32,61.1h0a28.617,28.617,0,0,0,20.5-8.5h0A28.617,28.617,0,0,0,61,32.1h0a29.448,29.448,0,0,0-8.5-20.6h0A28.7,28.7,0,0,0,32,2.9h0a28.7,28.7,0,0,0-20.5,8.6Z",
    fill: "#fbfbfb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_70",
    "data-name": "\\u8DEF\\u5F84 70",
    d: "M7.9,44.8h0L28.3,30.1a20.69,20.69,0,0,0,3.1,1.4c.2.1.2-.1.2-.1l-2.5-2.1a.909.909,0,0,1-.4-.8L31.1,4.4c-.1.1-.1.3-.2.4a.9.9,0,0,0-.1.5L27.3,29.4,8.1,44.5C8,44.6,7.9,44.7,7.9,44.8Z",
    fill: "#333f47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.b594d71cb42fce9062cb5d15f808778a.svg";
export { ForwardRef as ReactComponent };